import { DocumentsFindByDealRes } from '@dealstack/shared/lib/generated';
import { getDocumentLinkNames } from '@dealstack/frontend/shared/components/Documents/documentLinks.utils.ts';
import { InvestorDocumentRow } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Investors/InvestorDetailsV2/components/DocumentsCard/investorDocuments.types.ts';

export const mapDocumentsToRows = (
	documents: DocumentsFindByDealRes[] | undefined
): InvestorDocumentRow[] =>
	(documents ?? []).map((document) => ({
		id: document.id,
		name: document.name,

		classifications: (document.classifiers ?? [])
			.map((classifier) => classifier.name)
			.filter(Boolean)
			.join(', '),
		fileId: document.fileId,
		fileExtension: document.extension,
		linkedToNames: getDocumentLinkNames(document.documentLinks),
		isTransactionDocument: (document.documentLinks ?? []).some(
			(link) => !!link.buyerName || !!link.sellerName || !!link.issuerName
		),
	}));

export const MAX_VISIBLE_LINKED_NAMES = 2;

export const getLinkedNamesParts = (names: string[], visibleCount: number) => ({
	visible: names.slice(0, visibleCount).join(', '),
	hiddenCount: Math.max(names.length - visibleCount, 0),
});

export const formatLinkedToNames = (names: string[]): string => {
	const { visible, hiddenCount } = getLinkedNamesParts(names, MAX_VISIBLE_LINKED_NAMES);

	return hiddenCount > 0 ? `${visible} (+${hiddenCount})` : visible;
};
